import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgVisa = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 28 10"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="#172B85"
        fillRule="evenodd"
        d="M7 9.398H4.577L2.76 2.466c-.086-.32-.27-.601-.539-.734A7.9 7.9 0 0 0 0 .998V.732h3.904c.538 0 .942.4 1.01.866l.942 5L8.279.733h2.356zm4.981 0H9.693L11.577.732h2.289zm4.845-6.265c.067-.467.472-.734.943-.734a4.26 4.26 0 0 1 2.221.4l.404-1.866a5.8 5.8 0 0 0-2.086-.401c-2.221 0-3.838 1.2-3.838 2.867 0 1.267 1.145 1.933 1.953 2.333.875.4 1.211.667 1.144 1.067 0 .6-.674.866-1.346.866-.808 0-1.616-.2-2.356-.533l-.404 1.867c.809.332 1.683.467 2.49.467 2.491.065 4.04-1.134 4.04-2.934 0-2.267-3.165-2.4-3.165-3.4M28 9.398 26.183.732H24.23c-.404 0-.808.266-.943.666l-3.365 8h2.356l.47-1.266h2.895l.27 1.266zm-3.433-6.332.672 3.266h-1.884z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgVisa;
